import React, {useState, useEffect,} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import Campo from '../../Components/Campo';
import Header from '../../Components/Header';
import { Spinner  } from "react-awesome-spinners";
import FinderSelect from 'react-finderselect';
import TASelect from '../../Components/TASelectEdit2';
import Select from 'react-select';
import { Web } from '@material-ui/icons';


export default ({ListEsp, InfIdUse, InfIdConta, IdUse, IdConta, setAddList, setUsuariosContServ, UsuariosContServ,  Dados, Avisando, Fechar, Id, setAlert, setAlertTipo, MsgDesativar}) => {

const [Titulo, setTitulo] = useState("Treino Aluno");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [AtualizaAtivo, setAtualizaAtivo] = useState(false);
const [TemAtulizLimit, setTemAtulizLimit] = useState("");
const [TempDescanso, setTempDescanso] = useState("");
const [Treino, setTreino] = useState([]);
const [ListTreinSalv, setListTreinSalv] = useState([]);
const [ListCategoria, setListCategoria] = useState([]);
const [ListExercicio, setListExercicio] = useState([]);



useEffect(() => {
     ListCategorias()    
      }, [])

useEffect(() => {
    PreencherFormulario()   
  }, [ListEsp])

 useEffect(() => {
    ListandoTreinosSalvos()   
  }, [])
useEffect(() => {
  
  }, [Treino])

const ListCategorias = async ()=>{
          await Api.TAListdeCatTreino(IdConta, setListCategoria, setListExercicio )
        }

const ListandoTreinosSalvos = () => {
    Api.TAListTreinosSelect(IdConta, setListTreinSalv);
  };
 
 const handleToggle1 = () => {
    setAtualizaAtivo(!AtualizaAtivo);
  };
 
 const MudarAtivo= (key) => {
      setTreino(prevTreino =>
            prevTreino.map((item, i) =>
              i === key
                ? {
                    ...item,
                    Ativo: !item.Ativo,
                  }
                : item
            )
          );
  };

     

  const PrencherTreino = (key, target) => {
    var ListTreino = []
            for(let i in ListTreinSalv){
            
              if(ListTreinSalv[i].label === target.label){

                   ListTreino = ListTreinSalv[i].Treino;
              
                }
            
            }

      setTreino(prevTreino =>
            prevTreino.map((item, i) =>
              i === key
                ? {
                    ...item,
                    Treino: [...item.Treino, ...ListTreino],
                  }
                : item
            )
          );
  };
  const  EntrandoTreino = async (key)=>{
     setTreino(prevTreino =>
            prevTreino.map((item, i) =>
              i === key
                ? {
                    ...item,
                    Treino: [...item.Treino, {  
                                              Id: "",
                                              Nome: "", 
                                              IdCategoria: "",
                                              Categoria: "",
                                              ListExercicio:[],
                                              TempoAtivo: false, 
                                              BenefAtivo: false, 
                                              FazerAtivo: false, 
                                              MuscuAtivo: "",  
                                              Beneficios: "", 
                                              ComoFazer: "",  
                                              UrlTrenio: "",
                                              UrlMusculo: "",
                                              Concluido: false, 
                                              Serie:[{Quant:0, Concluido:false}],}],
                  }
                : item
            )
          );
       
         
        }
  const RemoverUltimoTreino = (key) => {
     setTreino(prevTreino =>
            prevTreino.map((item, i) =>
              i === key
                ? {
                    ...item,
                    Treino: item.Treino.slice(0, -1),
                  }
                : item
            )
          );
   
    };  
   const printValue4 = (key, key1, target) => {
    const novaCategoria = target.label;
    const novaCategoriaId = target.value;

          // Filtra exercícios da categoria selecionada
          const ListExer = ListExercicio.filter(
            (ex) => ex.Categoria === novaCategoria
          );

          // Atualiza o estado corretamente
          setTreino((prevTreino) =>
            prevTreino.map((item, i) =>
              i === key
                ? {
                    ...item,
                    Treino: item.Treino.map((exercicio, j) =>
                      j === key1
                        ? {
                            ...exercicio,
                            IdCategoria: novaCategoriaId,
                            Categoria: novaCategoria, 
                            ListExercicio: ListExer,   
                            UrlMusculo:"",
                            Id: "",                   
                            Nome: "",
                            TempoAtivo: false, 
                            BenefAtivo: false, 
                            FazerAtivo: false, 
                            MuscuAtivo: "",  
                            Beneficios: "", 
                            ComoFazer: "",  
                            UrlTrenio: "",
                            UrlMusculo: "",
                            Concluido: false,
                            Serie:[{Quant:0, Concluido:false}],                 
                          }
                        : exercicio
                    ),
                  }
                : item
            )
          );
        };


    const AddExecicio = (dados, key, key1) => {
          setTreino((prevTreino) =>
            prevTreino.map((item, i) =>
              i === key
                ? {
                    ...item,
                    Treino: item.Treino.map((exercicio, j) =>
                      j === key1
                        ? {
                            ...exercicio,
                            Id: dados.Id,
                            Nome: dados.Nome,
                            IdCategoria: dados.IdCategoria,
                            Categoria: dados.Categoria,
                            TempoAtivo: dados.TempoAtivo,
                            BenefAtivo: dados.BenefAtivo,
                            FazerAtivo: dados.FazerAtivo,
                            MuscuAtivo: dados.MuscuAtivo,
                            Beneficios: dados.Beneficios,
                            ComoFazer: dados.ComoFazer,
                            UrlTrenio: dados.UrlTrenio,
                            UrlMusculo: dados.UrlMusculo,
                            Serie:[{Quant:0, Concluido:false}],
                          }
                        : exercicio
                    ),
                  }
                : item
            )
          );
        };
   
const PreencherFormulario = () => {

    setAtualizaAtivo(ListEsp.AtualizaAtivo)
    setTemAtulizLimit(ListEsp.TemAtulizLimit)
    setTempDescanso(ListEsp.TempDescanso)
    setTreino(ListEsp.Treino)

  }


  const criando = ()=>{
 var TATempDescanso = parseInt(TempDescanso)
 var TATemAtulizLimit = parseInt(TemAtulizLimit)

  if(AtualizaAtivo){
    if(TATemAtulizLimit > 0 ){
     if(TATempDescanso > 0 ){
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
        Api.TAEditarAlunosTreino(TempDescanso, TemAtulizLimit, AtualizaAtivo, Treino, Id,  IdConta, InfIdUse,  IdUse,   UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList);
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
        setMsgErro("O Tempo de Desconso Tem Que Ser Maior que 0.")
    }
     } else {
        setMsgErro("O Tempo de Desconso Tem Que Ser Maior que 0.")
    }

  } else {

    if(TATempDescanso > 0 ){
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
        Api.TAEditarAlunosTreino(TempDescanso, TemAtulizLimit, AtualizaAtivo, Treino, Id,  IdConta, InfIdUse,  IdUse,   UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList);
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
        setMsgErro("O Tempo de Desconso Tem Que Ser Maior que 0.")
    }
   }
   
  }


        const AdicionandoSerie = (indexTreino, indexExercicio) => {
        setTreino((prevTreino) =>
          prevTreino.map((treino, i) =>
            i === indexTreino
              ? {
                  ...treino,
                  Treino: treino.Treino.map((exercicio, j) =>
                    j === indexExercicio
                      ? {
                          ...exercicio,
                          Serie: [
                            ...exercicio.Serie,
                            { Quant: 0, Concluido: false }
                          ],
                        }
                      : exercicio
                  ),
                }
              : treino
          )
        );
      };
  
     const RemoverSerie = (indexTreino, indexExercicio) => {
        setTreino((prevTreino) =>
          prevTreino.map((treino, i) =>
            i === indexTreino
              ? {
                  ...treino,
                  Treino: treino.Treino.map((exercicio, j) =>
                    j === indexExercicio
                      ? {
                          ...exercicio,
                          Serie: exercicio.Serie.slice(0, -1), // remove a última série
                        }
                      : exercicio
                  ),
                }
              : treino
          )
        );
      };
      
          const alterarQuant = (indexTreino, indexExercicio, indexSerie, value) => {
                setTreino((prevTreino) =>
                  prevTreino.map((treino, tIdx) =>
                    tIdx === indexTreino
                      ? {
                          ...treino,
                          Treino: treino.Treino.map((exercicio, eIdx) =>
                            eIdx === indexExercicio
                              ? {
                                  ...exercicio,
                                  Serie: exercicio.Serie.map((serie, sIdx) =>
                                    sIdx === indexSerie
                                      ? { ...serie, Quant: value } // atualiza a Quant da série específica
                                      : serie
                                  ),
                                }
                              : exercicio
                          ),
                        }
                      : treino
                  )
                );
        };
       const getCategoriaDefault = (categoriaNome) => {
        if (!categoriaNome || !ListCategoria.length) return null;
        return ListCategoria.find(cat =>
          cat.label === categoriaNome || cat.value === categoriaNome
        ) || null;
      };

   


        return (
            <>
<div className="content-wrapper">
                <Header 
                Titulo={Titulo}
                Avisando={Avisando}
                Fechar={Fechar}
                />
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
            
              <div className="invoice p-3 mb-3">
              {/* title row */}
              <div className="row">
                <div className="col-12">
                  <h4>
                    <i className="far fa-address-card" /> Aluno 
                  </h4>
                </div>
                {/* /.col */}
              </div>
              {/* info row */}
              <div className="col-sm-4 invoice-col">
                  <address>
                    {Loading  ?
                    <>
                      <Spinner 
                      size={64}
                      color={"#5d0bf7"}
                      sizeUnit={'px'} 
                      /><br />
                      </>
                      :
                      <>
                      {Dados &&
                  <>
                  {Dados.Alunos.Btn.botão_AtualizarTreino &&
                  <>
                     <div className="col-12">
                        <Butao 
                        style={"btn .btn-sm btn-info"}
                        titulo={"Atualizar"}
                        onClick={()=>criando()}
                        />  
                    </div><br />
                            </>
                            }
                            </>
                            }
                   
                    
                     {MsgErro !== "" &&
                    <>
                    <div class="alert alert-danger alert-dismissible">
                  
                  <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                  {MsgErro}
                </div>
                   
                    </>
                    }
                    </>
                    }

                     <div style={{ textAlign: "center",  }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={handleToggle1}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: AtualizaAtivo ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: AtualizaAtivo ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {AtualizaAtivo ? "Atualização do Treino Ativo" : "Atualização do Treino Desativado"}
                          </span>
                        </label>
                      </div>
                      {AtualizaAtivo &&
                      <>
                     
                   <strong>Quantidade de Mês para Atualização</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={TemAtulizLimit}
                              onChange={t=>setTemAtulizLimit(t.target.value)}
                              maxLength={2}
                              className="border p-2 rounded"
                              placeholder="00"
                              size={4}
                            />

                            </div> 
                    <br />
                     </>

                      }
                    <strong>Tempo de Descanso (Segundos)</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={TempDescanso}
                              onChange={t=>setTempDescanso(t.target.value)}
                              maxLength={2}
                              className="border p-2 rounded"
                              placeholder="00"
                              size={4}
                            />

                            </div> 
                    <br />
    
                  </address>
                    </div>
              <div className="row invoice-info">
                
                    {Treino.length !== 0 &&
                    <>
                    {Treino.map((item, key)=>(
                      <div className="col-sm-4 invoice-col">
                          
                  <div className="card p-2 shadow-sm">
                    <address>
                     <strong  style={{ fontSize:20  }}>{item.Nome}</strong><br />
                     <strong>Digite o Nome do Treino</strong><br />
                     <input
                      type="text"
                      value={item.Nome}
                      onChange={(e) => {
                        const novoNome = e.target.value;
                        setTreino(prevTreino =>
                          prevTreino.map((t, i) =>
                            i === key
                              ? { ...t, Nome: novoNome }
                              : t
                          )
                        );
                      }}
                      style={{
                        width: "100%",
                        fontSize: "18px",
                        fontWeight: "bold",
                        textAlign: "center",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        padding: "4px 8px",
                        marginBottom: "6px",
                      }}
                      placeholder="Digite o nome do treino"
                    />
                 <div style={{ textAlign: "center",  }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={()=>MudarAtivo(key)}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: item.Ativo ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: item.Ativo ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {item.Ativo ? item.Nome +" Ativo" : item.Nome +" Desativado"}
                          </span>
                        </label>
                      </div>
                      {item.Ativo &&
                      <>
                       <strong>Treinos Salvos</strong><br />  
                     
                      <Select
                          
                          onChange={(target) => PrencherTreino(key, target)}
                          options={ListTreinSalv}
                          placeholder={"Escolha Treinos Salvos"}
                        />  
                       <strong>Adiconar {item.Treino && item.Treino.length > 0 ?"e Remover":""} Exercício</strong><br />
                     <button
                      onClick={()=>EntrandoTreino(key)}
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "10%",
                        border: "none",
                        outline: "none",    
                        backgroundColor: "#2563eb",
                        color: "#fff",
                        fontSize: "25px",
                        cursor: "pointer",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                        marginBottom:20
                      }}
                    >
                    +
                  </button>
                   {item.Treino && item.Treino.length > 0 && (
                    <>
                   <button
                      onClick={()=>RemoverUltimoTreino(key)}
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "10%",
                        border: "none",
                        outline: "none",
                        marginLeft:20,    
                        backgroundColor: "#cb605c",
                        color: "#fff",
                        fontSize: "25px",
                        cursor: "pointer",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                      }}
                    >
                    -
                  </button><br />
                  </>  
                   )}    
                       {item.Treino && item.Treino.length > 0 && (
                    <>
                    {item.Treino.map((item1, key1)=>(
                       <div
                        style={{
                          boxShadow: "0 -4px 6px -2px rgba(0, 0, 0, 0.3)", // sombra no topo
                          padding: "20px",
                          borderRadius: "10px",
                          backgroundColor: "#fff",
                        }}
                      > 
                      <>   
                                 
                        <strong style={{ fontSize: 20 }}>{key1 + 1}° Exercício</strong>                  
                      <br />

                     <strong>Categoria</strong><br />
                     
                      <string>{}</string>
                      <Select
                           value={getCategoriaDefault(item1.Categoria)}
                            onChange={(target) => printValue4(key, key1, target)}
                            options={ListCategoria}
                            placeholder="Escolha a Categoria"
                          />
                     
                      {item1.ListExercicio.length > 0 && (
                       <>
                      <TASelect
                        key={`TA-${key}-${key1}-${item1.IdCategoria ?? item1.Categoria ?? 'none'}`}
                        data={item1.ListExercicio}
                        Chave={key}
                        Chave1={key1}
                        AddExecicio={AddExecicio}
                        Treino={item1}
                      />
                           {item.Nome &&
                      <>

                      {item1.TempoAtivo === false &&
                       <>
                      
                       <strong>Add e Remover Série:</strong><br />
                        <button
                      onClick={() => AdicionandoSerie(key, key1)}
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "10%",
                        border: "none",
                        outline: "none",    
                        backgroundColor: "#2563eb",
                        color: "#fff",
                        fontSize: "15px",
                        cursor: "pointer",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                        marginBottom:"5px"
                      }}
                    >
                    +
                  </button>
                   <button
                      onClick={() =>RemoverSerie(key, key1)}
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "10%",
                        border: "none",
                        outline: "none",
                        marginLeft:5,    
                        backgroundColor: "#cb605c",
                        color: "#fff",
                        fontSize: "15px",
                        cursor: "pointer",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                        marginBottom:"5px"
                      }}
                    >
                    -
                  </button><br />
                   </>
                    }
                    {item1.TempoAtivo ?
                    <>
                    <strong>Tempo em Minutos:</strong><br />
                    </>
                    :
                    <>
                    <strong>Repetições:</strong><br />
                    </>
                    }
                   
                   <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "10px" }}>
                      {item1.Serie.map((item2, key2)=>(
                        <>
                       
                        <div className="input_cadatro">
                                  
                                  <input
                                  type="text"
                                  value={item2.Quant}
                                  onChange={(e) => alterarQuant(key, key1, key2, Number(e.target.value))}
                                  maxLength={2}
                                  className="border p-2 rounded"
                                  placeholder="00"
                                  size={2}
                                />

                               </div> 
                        
                        </>
                        ))}
                        </div>
                        </>
                        }               
                         </>                 
                          )}
                      </>
                        </div> 
                       ))}
                    
                      </>
                      )}
                      </>

                      }
                    
                    </address>
                    </div>
                   </div>
                    ))}
                    
                    </>
                    }
                   
              </div>
              <div className="row no-print">
              </div>
              
            
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}